const urlPattern = /((https?:\/\/|www\.)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*))/g;

const parseLink = (text: string) => text
  .split(/(<[^>]*>)/g)
  .map((part, index) => {
    if (index % 2 === 1) {
      return part;
    }

    return part.replace(urlPattern, (x) => {
      let link = x;
      if (link.startsWith("www.")) {
        link = `https://${link}`;
      }
      if (link.endsWith(".")) {
        link = link.slice(0, -1);
      }
      return `<a style="color: var(--theme-palette-secondary-main); text-decoration: underline;" href="${link}" target="_blank">${x}</a>`;
    });
  })
  .join("");

export default parseLink;